import React from 'react'
import { Grid, Icon, Popup } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { ChartHeader } from './ChartHeader'
import '../../../assets/styles/dashboard.less'

interface IYearSwitcherProps {
  title: string
  yearOffset: number
  setYear: (yearOffset: number) => void
  loading?: boolean
}

export const YearSwitcher: React.FC<IYearSwitcherProps> = props => {
  const { setYear, yearOffset } = props
  const { t } = useTranslation()

  const isYearCurrent = yearOffset === 0

  const incrementYear = () => setYear(yearOffset + 1)
  const decrementYear = () => setYear(yearOffset - 1)

  return (
    <Grid>
      <Grid.Row columns='equal'>
        <Grid.Column>
          <ChartHeader title={props.title} loading={props.loading} />
        </Grid.Column>
        <Grid.Column textAlign='right'>
          <Popup content={t('global.back')} trigger={<Icon name='chevron left' size='large' onClick={decrementYear} />} />
          <Popup
            content={t('global.next')}
            trigger={<Icon name='chevron right' size='large' disabled={isYearCurrent} onClick={incrementYear} />}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
